import "./SignInPending.scss";
import React, { useState, useEffect } from "react";
import {
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonLoading,
  // IonInfiniteScroll,
  // IonInfiniteScrollContent,
} from "@ionic/react";
import { useTracked } from "../../state";
import {
  updateRequestHistory,
  getRequestHistoryByIdentity,
} from "../../api/requestHistory";
import { usePlatform } from "../../utils/hooks";
import moment from "moment";
import checkCircleIcon from "../../assets/svg/check-circle.svg";
import xCircleIcon from "../../assets/svg/x-circle.svg";
import { Plugins } from "@capacitor/core";
import { verifyLogin } from "../../api/chain";
import { ShowToastErrorMessage } from "../../utils/helpers/ToastMessage";
const { App } = Plugins;

interface Props {
  tabValue: any;
}

const SignInPending: React.FC<Props> = ({ tabValue }) => {
  const [state] = useTracked();
  const platform = usePlatform();
  const [lastPending, setLastPending] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
  // const pageSize = 20;
  const filter = { status: "PENDING" };
  // const limit = 20;

  useEffect(() => {
    if (state.authorization && state.identity && state.token) {
      fetchData(state.identity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.authorization, state.identity, state.token]);

  React.useEffect(() => {
    if (state.authorizationActionTimestamp) {
      fetchData(state.identity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.authorizationActionTimestamp]);

  useEffect(() => {
    if (state.identity && tabValue === "pending") {
      fetchData(state.identity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue]);

  const fetchData = async (identity: string) => {
    try {
      setIsLoading(true);
      const requestsHistory: any = await getRequestHistoryByIdentity(
        identity,
        filter
        // limit,
        // pageSize
      );
      if (requestsHistory?.status === 200) {
        const { data = [] } = requestsHistory;
        const groupArrayData = groupDataByDate(data);
        setLastPending(groupArrayData);
      }

      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  // const loadData = async(ev: any) => {
  //     try {
  //       const requestsHistory: any = await getRequestHistoryByIdentity(
  //         state.identity,
  //         pageSize
  //       );
  //       if (requestsHistory?.status === 200) {
  //         const { data = [], totalCount, pageSize } = requestsHistory;
  //         const max = data.length + pageSize;
  //         const min = max - pageSize;
  //         const newData = [];
  //         for (let i = min; i < data.length; i++) {
  //           newData.push(data[i]);
  //         }
  //         const groupArrayData = groupDataByDate(newData);
  //         setLastPending([
  //           ...data,
  //           ...groupArrayData
  //         ]);
  //         if (data.length === totalCount) {
  //           setInfiniteDisabled(true);
  //         }
  //         ev.target.complete();
  //       }
  //     } catch (e) {
  //       console.log(e);
  //     }
  // };

  const groupDataByDate = (data: any) => {
    const pendingByDate = data.reduce((groups: any, pendingDate: any) => {
      const date = moment.unix(pendingDate.createdAt).format("YYYY-MM-DD");
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(pendingDate);
      return groups;
    }, {});

    const groupArrays = Object.keys(pendingByDate).map((date) => {
      return {
        date,
        pendingHistory: pendingByDate[date],
      };
    });

    return groupArrays;
  };

  const onApprove = async (
    id: any,
    identity: any,
    appId: any,
    requestToken?: any,
    authRequestId?: any
  ) => {
    try {
      setIsLoading(true);
      const token = requestToken ? requestToken : state.token;

      if (id) {
        const response: any = await verifyLogin({
          appId,
          token,
          authRequestId,
          requestId: id,
        });

        if (response?.status === 200) {
          fetchData(state.identity);
        } else {
          ShowToastErrorMessage(
            response?.message ? response.message : "Unable to allow request."
          );
        }
      }

      //NOTE: might be removed
      if (appId === 2) {
        // abaxx messenger
        launchApp();
      }

      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  const onDeny = async (
    requestId: any,
    identity: any,
    appId: any,
    requestToken?: any
  ) => {
    const token = requestToken ? requestToken : state.token;
    if (state.mqm) {
      await state.mqm.pubnub.publish({
        channel: identity,
        meta: {
          type: "authorizationDeny",
        },
        message: { identity, token, appId },
      });
    }

    if (requestId) {
      // update request history if it has request ID
      updateRequestHistory(requestId, {
        status: "DENIED",
      }).then((response: any) => {
        fetchData(state.identity);
        console.log("request history response -->", response);
      });
    }
  };

  const launchApp = async () => {
    try {
      if (platform === "ios" || platform === "android") {
        let url = process.env.REACT_APP_MESSENGER_URL || "https://app.abaxx.id";

        const canOpen = await App.canOpenUrl({ url });

        if (canOpen && canOpen.value) {
          await App.openUrl({ url });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getActionTitle = (val: any) => {
    // temporary: need to map out ACTION from api.
    if (val.requestAction?.includes("api-key")) {
      return "Action";
    } else {
      return "Sign In";
    }
  };

  return (
    <React.Fragment>
      {isLoading && <IonLoading isOpen={isLoading} />}
      <IonList className="sign-in-pending-list">
        {lastPending.map((val: any, index: number) => {
          return (
            <React.Fragment key={index}>
              <div className="list-header-title">
                {moment(val.date).isSame(moment(), "day")
                  ? "Today"
                  : moment(val.date).format("DD MMM YYYY")}
              </div>
              {val.pendingHistory?.map((childVal: any, idx: number) => {
                return (
                  <IonItem key={idx} lines="full">
                    <IonLabel>
                      {getActionTitle(val)} -{" "}
                      {childVal?.appId === "1" && "Verifier"}
                      {childVal?.appId === "2" && "Messenger"}
                      {childVal?.appId === "3" && "Exchange"}
                      {childVal?.appId === "4" && "Sign Abaxx"}
                      {childVal?.appId === "5" && "Clearing"}
                      <div className="list-subtitle">
                        <h6>
                          Request{" "}
                          {moment
                            .unix(childVal.createdAt)
                            .format("DD MMM YYYY, hh:mm")}
                        </h6>
                      </div>
                    </IonLabel>
                    <IonLabel slot="end" style={{ marginRight: "0" }}>
                      <div className="list-subtitle-second">
                        <IonIcon
                          color="danger"
                          slot="start"
                          icon={xCircleIcon}
                          onClick={() => {
                            onDeny(
                              childVal.id,
                              childVal.user.identity,
                              childVal.appId,
                              childVal.token
                            );
                          }}
                        />
                        <IonIcon
                          slot="start"
                          icon={checkCircleIcon}
                          onClick={() => {
                            onApprove(
                              childVal.id,
                              childVal.user.identity,
                              childVal.appId,
                              childVal.token,
                              childVal.requestId
                            );
                          }}
                        />
                      </div>
                    </IonLabel>
                  </IonItem>
                );
              })}
            </React.Fragment>
          );
        })}
      </IonList>
      {/* <IonInfiniteScroll
                onIonInfinite={loadData}
                threshold="100px"
                disabled={isInfiniteDisabled}
                >
            <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="Loading more data..."
            ></IonInfiniteScrollContent>
            </IonInfiniteScroll> */}
    </React.Fragment>
  );
};

export default SignInPending;
